export default __webpack_public_path__ + "static/media/cesky.b554c0bb.svg";